import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  filterArea: {
    display: "flex",
    alignItems: "flex-end",
    marginBottom: 15,
    width: "100%",
  },
  filter: {
    width: "180px",
    marginLeft: "auto",
  },
  accountImage: {
    float: "left",
    position: "absolute",
    marginTop: "-8px",
    marginLeft: "-32px",
  },
  enabledImage: {
    position: "absolute",
    marginTop: "-16px",
  },
  accounText: {},
}));

export default useStyles;
